<div class="filters_view_bg" [hidden]="!searchDropDownToggle" (click)="searchDropDownToggle = false"></div>
<div class="search-path">
    <button class="btn btn-primary" (click)="searchDropDownToggle = !searchDropDownToggle">
        Filter
    </button>
    <div class="searchDropdown" [hidden]="!searchDropDownToggle" style="z-index: 51;">
        
      <form [formGroup]="searchForm" autocomplete="off" (ngSubmit)="onSubmit()">
           

            <div *ngIf="showCustomer === true" class="dropdownFields">
                <label>Customer</label>
                <!-- <ng-select [items]="customerModel"  bindValue="id" placeholder="Select a customer"
                    formControlName="CUSTOMER" appendTo="body">
                </ng-select> -->
                <ng-select [multiple]="false"
                    formControlName="ACCOUNT_ID_IN" appendTo="body" placeholder="">
                    <ng-option *ngFor="let item of accountLists" [value]="item.id">{{item?.accountName}}</ng-option>
                </ng-select>
            </div>

            <div *ngIf="showCustomerAndWarehouse === true" class="dropdownFields multi-select-height">
                <label>Customer & Warehouse</label>
                <!-- <ng-select [multiple]="true" [items]="warehouseList" [multiple]="true" bindLabel="warehouseName"
                    bindValue="id" placeholder="Warehouse name" formControlName="WAREHOUSE_ID_IN" appendTo="body">
                </ng-select> -->
                <ng-select [multiple]="true" (change)="selectWarehouse($event)"
                    formControlName="MAPPING_IN" appendTo="body" placeholder="" (search)="onSearch($event)">
                    <ng-template ng-header-tmp>
                      <div class="d-flex justify-content-end">
                          <button class="btn ng-select-btn btn-primary ms-1"
                                  (click)="onSelectAll('MAPPING_IN',accountMappingList)">Select All</button>
                          <button class="btn ng-select-btn btn reset-btn btn-cancel ms-1"
                                  (click)="onClearAll('MAPPING_IN')">Clear All</button>
                      </div>
                    </ng-template>
                    <ng-option *ngFor="let item of accountMappingList" [value]="item.id">{{item?.accountName}} - {{item?.warehouseName}}</ng-option>
                </ng-select>
            </div>

            <!-- Warehouse Dropdown (Visible based on Input) -->
            <div *ngIf="showWarehouse === true" class="dropdownFields">
                <label>Warehouse</label>
                <ng-select formControlName="WAREHOUSE_ID_IN" appendTo="body" placeholder=" Select Warehouse">
                    <ng-option *ngFor="let item of wareHouseList" [value]="item?.id">{{item?.warehouseName}}</ng-option>
                </ng-select>
            </div>

            
            <!-- Zone -->
            <div *ngIf="showZone=== true" class="dropdownFields multi-select-height">
                <label>Zone</label>
                <ng-select [multiple]="true" formControlName="ZONE_IN" placeholder="zone" appendTo="body">
                    <ng-template ng-header-tmp>
                      <div class="d-flex justify-content-end">
                          <button class="btn ng-select-btn btn-primary ms-1"
                                  (click)="onSelectAll('ZONE_IN',zoneList)">Select All</button>
                          <button class="btn ng-select-btn btn reset-btn btn-cancel ms-1"
                                  (click)="onClearAll('ZONE_IN')">Clear All</button>
                      </div>
                    </ng-template>
                    <ng-option *ngFor="let item of zoneList" [value]="item.id">{{item.name}}</ng-option>
                </ng-select>
            </div>

            <!-- Region -->
            <div *ngIf="showRegion=== true" class="dropdownFields multi-select-height">
                <label>Region</label>
                <ng-select [multiple]="true" formControlName="REGION_IN" placeholder="region" appendTo="body">
                    <ng-option *ngFor="let item of regionList" [value]="item.id">{{item.name}}</ng-option>
                </ng-select>
            </div>
            <!-- City  -->
            <div *ngIf="showCity=== true" class="dropdownFields multi-select-height">
                <label>City</label>
                <ng-select [multiple]="true" formControlName="CITY" placeholder="City" appendTo="body">
                  <ng-template ng-header-tmp>
                    <div class="d-flex justify-content-end">
                        <button class="btn ng-select-btn btn-primary ms-1"
                                (click)="onSelectAll('CITY',cityList)">Select All</button>
                        <button class="btn ng-select-btn btn reset-btn btn-cancel ms-1"
                                (click)="onClearAll('CITY')">Clear All</button>
                    </div>
                  </ng-template>  
                  <ng-option *ngFor="let item of cityList" [value]="item.id">{{item.name}}</ng-option>
                </ng-select>
            </div>

            <!-- Expenses Type -->
            <div *ngIf="showExpenseType === true" class="dropdownFields multi-select-height">
                <label>Expense</label>
                <ng-select [multiple]="true" formControlName="EXPENSE_IN" placeholder="expense" appendTo="body" (search)="onExpenseSearch($event)">
                    <ng-template ng-header-tmp>
                      <div class="d-flex justify-content-end">
                          <button class="btn ng-select-btn btn-primary ms-1"
                                  (click)="onSelectAllExpense('EXPENSE_IN',expenseTypeList)">Select All</button>
                          <button class="btn ng-select-btn btn reset-btn btn-cancel ms-1"
                                  (click)="onClearAll('EXPENSE_IN')">Clear All</button>
                      </div>
                    </ng-template>
                    <ng-option *ngFor="let item of expenseTypeList" [value]="item.id">{{item.expenseName}}</ng-option>
                </ng-select>
            </div>

            <!-- Financial Year -->
            <div *ngIf="showFY === true" class="dropdownFields multi-select-height">
                <label>Financial Year</label>
                <ng-select [multiple]="true" formControlName="YEAR_IN" placeholder="financial year"
                    appendTo="body">
                    <ng-template ng-header-tmp>
                      <div class="d-flex justify-content-end">
                          <button class="btn ng-select-btn btn-primary ms-1"
                                  (click)="onSelectAll('YEAR_IN',financialYearList)">Select All</button>
                          <button class="btn ng-select-btn btn reset-btn btn-cancel ms-1"
                                  (click)="onClearAll('YEAR_IN')">Clear All</button>
                      </div>
                    </ng-template>
                    <ng-option *ngFor="let item of financialYearList" [value]="item.id">{{item.name}}</ng-option>
                </ng-select>
            </div>
            <!-- Month -->
            <div *ngIf="showMonth === true" class="dropdownFields readonlyfield">
                <label>Month</label>
                <p-calendar
                    (onSelect)="setMonth($event)"
                    formControlName="DUMMY_FILTER_TWO"
                    view="month"
                    dateFormat="MM"
                    [readonlyInput]="true"
                    inputId="monthpicker"
                    [ngClass]="{disabled: searchForm.controls['DUMMY_FILTER_THREE'].value}"
                    appendTo="body"
                ></p-calendar>
            </div>

            <!--Billing Type -->
            <div *ngIf="showBillingType === true" class="dropdownFields multi-select-height">
                <label>Billing Type</label>
                <ng-select [multiple]="true" formControlName="BILLINGTYPE" placeholder="billing type" appendTo="body">
                    <ng-option value="Fixed">Fixed</ng-option>
                    <ng-option value="Variable">Variable</ng-option>
                    <ng-option value="Credit Note">Credit Note</ng-option>
                    <ng-option value="Unbilled">Unbilled</ng-option>
                </ng-select>
            </div>

            <!-- Units of Measurement -->
            <div *ngIf="showUnitsOfMeasurement === true" class="dropdownFields multi-select-height">
                <label>Units of Measurement</label>
                <ng-select [multiple]="true" formControlName="UNITOFMEASUREMENT" placeholder="unit of measurement"
                    appendTo="body">
                    <ng-option value="BAGS">BAGS</ng-option>
                    <ng-option value="BOX">BOX</ng-option>
                    <ng-option value="KG">KG</ng-option>
                    <ng-option value="LINE">LINE</ng-option>
                    <ng-option value="LITER">LITER</ng-option>
                </ng-select>
            </div>

            <!-- Expenses Head -->
            <!-- <div *ngIf="showExpensesHead === true" class="dropdownFields">
                <label>Expenses</label>
                <ng-select [multiple]="true" formControlName="EXPENSESHEAD" placeholder="Expenses" appendTo="body">
                    <ng-option value="courierCharges">Capex-Interest</ng-option>
                    <ng-option value="dieselConsumption">Courier Charges-[Cash]</ng-option>
                    <ng-option value="dieselConsumption">Courier Charges-[Corporate]</ng-option>
                    <ng-option value="drinkingWaterChanges">Diesel Consumption[Cash]</ng-option>
                    <ng-option value="drinkingWaterChanges">Diesel Consumption[Corporate]</ng-option>
                </ng-select>
            </div> -->

            <!-- Invoice Status -->
            <!-- <div *ngIf="showInvoiceStatus === true" class="dropdownFields">
                <label>Invoice Status</label>
                <ng-select [multiple]="true" formControlName="INVOICESTATUS" placeholder="invoice status"
                    appendTo="body">
                    <ng-option value="withinBudget">Within Budget</ng-option>
                    <ng-option value="overrun">Overrun</ng-option>
                </ng-select>
            </div> -->
            <!-- Vendor -->
            <!-- <div *ngIf="showVendor === true" class="dropdownFields">
                <label>Vendor</label>
                <ng-select [multiple]="true" formControlName="VENDOR" placeholder="vendor"
                    appendTo="body">
                    <ng-option value="select">select</ng-option>
                    <ng-option value="select">select</ng-option>
                </ng-select>
            </div> -->
            <!-- Catagory -->
            <div *ngIf="showCategory === true" class="dropdownFields multi-select-height">
                <label>Category</label>
                <ng-select [multiple]="true" formControlName="CATEGORY_IN"  placeholder="Select category" appendTo="body">
                  <ng-option *ngFor="let category of category" [value]="category.id">
                    {{ category.categoryDescription }}
                  </ng-option>
                </ng-select>
              </div>
            <!-- Expense mode -->
            <div *ngIf="showExpenseMode === true || showInvoiceNo === true" class="dropdownFields multi-select-height">
                <label>Expense Mode</label>
                <ng-select [multiple]="true" formControlName="EXPENSE_MODE_IN" placeholder="Select expense mode"
                    appendTo="body">
                    <ng-option *ngFor="let item of expenseMode" [value]="item.id">
                        {{item.name}}
                    </ng-option>
                </ng-select>
            </div>
            <!-- USER NAME -->
            <div *ngIf="showUserName === true" class="dropdownFields">
                <label>User Name</label>
                <input type="text" class="form-control" formControlName="USER_NAME" placeholder="">
            </div>

            <!-- USER NAME -->
            <!-- <div *ngIf="showUserName === true" class="dropdownFields">
              <label>Employee Name</label>
              <input type="text" class="form-control" formControlName="NAME_IN" placeholder="User name">
          </div> -->
             <!-- USER NAME -->
             <div *ngIf="showVendorCode === true" class="dropdownFields">
              <label>Vendor Code</label>
              <input type="text" class="form-control" formControlName="VENDOR_CODE" placeholder="">
          </div>
          <!-- Vendor NAME -->
          <div *ngIf="showVendorCode === true" class="dropdownFields">
            <label>Vendor Name</label>
            <input type="text" class="form-control" formControlName="VENDOR_NAME_IN" placeholder="">
        </div>
        
            <!-- USER EMAIL -->
            <div *ngIf="showUserEmail === true" class="dropdownFields">
                <label>Email</label>
                <input type="text" class="form-control" formControlName="EMAIL_IN">
            </div>
            <!-- USER Mobile No -->
            <div *ngIf="showUserMobileNo === true" class="dropdownFields">
                <label>Mobile No.</label>
                <input type="text" class="form-control" formControlName="MOBILE_NUMBER">
            </div>
            <!-- BUDGET TYPE -->
            <div *ngIf="showBudgetType === true" class="dropdownFields multi-select-height">
                <label>Budget Type</label>
                <ng-select [multiple]="true" formControlName="BUDGET_TYPE"  placeholder="Select budget type" appendTo="body">
                  <ng-option *ngFor="let item of budgetType" [value]="item.id">
                    {{ item.name }}
                  </ng-option>
                </ng-select>
              </div>
            <!-- DESIGNATION -->
            <div *ngIf="showDesignation === true" class="dropdownFields multi-select-height">
                <label>Designation</label>
                <ng-select [multiple]="true" formControlName="DESIGNATION_IN"   appendTo="body">
                  <ng-template ng-header-tmp>
                      <div class="d-flex justify-content-end">
                          <button class="btn ng-select-btn btn-primary ms-1"
                                  (click)="onSelectAll('DESIGNATION_IN',designation)">Select All</button>
                          <button class="btn ng-select-btn btn reset-btn btn-cancel ms-1"
                                  (click)="onClearAll('DESIGNATION_IN')">Clear All</button>
                      </div>
                    </ng-template>
                  <ng-option *ngFor="let item of designation" [value]="item.id">
                    {{ item.name }}
                  </ng-option>
                </ng-select>
              </div>
            <!-- OWNERSHIP TYPE -->
            <div *ngIf="showOwnershipType === true" class="dropdownFields multi-select-height">
                <label>Ownership Type</label>
                <ng-select [multiple]="true" formControlName="OWNERSHIP_TYPE_IN"   appendTo="body">
                  <ng-option *ngFor="let item of ownershipType" [value]="item.id">
                    {{ item.name }}
                  </ng-option>
                </ng-select>
              </div>
            <!-- WH TYPE -->
            <div *ngIf="showWarehouseType === true" class="dropdownFields multi-select-height">
                <label>Warehouse Type</label>
                <ng-select [multiple]="true" formControlName="WAREHOUSE_TYPE"   appendTo="body">
                    <ng-option value="STAND_ALONE">Stand-Alone</ng-option>
                    <ng-option value="MULTI_USER">Multi-user</ng-option>
                </ng-select>
              </div>
            <!-- DEPARTMENT -->
            <div *ngIf="showDepartment === true" class="dropdownFields multi-select-height">
                <label>Department</label>
                <ng-select [multiple]="true" formControlName="DEPARTMENT_IN"   appendTo="body">
                  <ng-option *ngFor="let item of department" [value]="item.id">
                    {{ item.name }}
                  </ng-option>
                </ng-select>
              </div>
            <!-- EXPENSE CATEGORY -->
            <div *ngIf="showExpenseCategory === true" class="dropdownFields multi-select-height">
                <label>Expense Category</label>
                <ng-select [multiple]="true" formControlName="CATEGORY_IN" appendTo="body">
                  <ng-template ng-header-tmp>
                      <div class="d-flex justify-content-end">
                          <button class="btn ng-select-btn btn-primary ms-1"
                                  (click)="onSelectAll('CATEGORY_IN',expenseCategory)">Select All</button>
                          <button class="btn ng-select-btn btn reset-btn btn-cancel ms-1"
                                  (click)="onClearAll('CATEGORY_IN')">Clear All</button>
                      </div>
                    </ng-template>
                  <ng-option *ngFor="let item of expenseCategory" [value]="item.id">
                    {{ item.name }}
                  </ng-option>
                </ng-select>
              </div>
            <!-- ROLE MANAGEMENT -->
            <div *ngIf="showRoleName === true" class="dropdownFields multi-select-height">
                <label>Employee Position</label>
                <ng-select [multiple]="true" formControlName="USER_ROLE"   appendTo="body">
                  <ng-template ng-header-tmp>
                    <div class="d-flex justify-content-end">
                        <button class="btn ng-select-btn btn-primary ms-1"
                                (click)="onSelectAll('USER_ROLE',roleList)">Select All</button>
                        <button class="btn ng-select-btn btn reset-btn btn-cancel ms-1"
                                (click)="onClearAll('USER_ROLE')">Clear All</button>
                    </div>
                  </ng-template>
                  <ng-option *ngFor="let item of roleList" [value]="item.id">
                    {{ item.roleDescription }}
                  </ng-option>
                </ng-select>
              </div>
              <!--  showCurrentApproval  -->
            <div *ngIf="showCurrentApproval === true || showUserAgeing === true" class="dropdownFields multi-select-height">
              <label>{{showUserAgeing ? 'User Name':'Current Apporval'}}</label>
              <ng-select [multiple]="true" formControlName="USER_ID_IN"   appendTo="body" [typeahead]="EmpInput$" (search)="EmpInput$.next($event.term)">
                <ng-template ng-header-tmp>
                    <div class="d-flex justify-content-end">
                        <button class="btn ng-select-btn btn-primary ms-1"
                                (click)="onSelectAll('USER_ID_IN',EmployeesList)">Select All</button>
                        <button class="btn ng-select-btn btn reset-btn btn-cancel ms-1"
                                (click)="onClearAll('USER_ID_IN')">Clear All</button>
                    </div>
                  </ng-template>
                <ng-option *ngFor="let item of EmployeesList" [value]="item.id">
                  {{ item.fullName }}
                </ng-option>
              </ng-select>
            </div>
              <!-- EMPLOYEE NAME -->
              <div *ngIf="showEmployeeName === true" class="dropdownFields">
                <label>Employee Name</label>
                <input type="text" class="form-control" formControlName="USER_NAME">
            </div>
          
            <!-- INVOICE List  -->
            <div *ngIf="showInvoiceNo === true || showVendor === true" class="dropdownFields multi-select-height">
              <label>Vendor</label>
              <ng-select [multiple]="true" formControlName="VENDOR_ID_IN"   appendTo="body" [typeahead]="vendorInput$" (search)="vendorInput$.next($event.term)">
                <ng-template ng-header-tmp>
                    <div class="d-flex justify-content-end">
                        <button class="btn ng-select-btn btn-primary ms-1"
                                (click)="onSelectAll('VENDOR_ID_IN',vendorsList)">Select All</button>
                        <button class="btn ng-select-btn btn reset-btn btn-cancel ms-1"
                                (click)="onClearAll('VENDOR_ID_IN')">Clear All</button>
                    </div>
                  </ng-template>
                <ng-option *ngFor="let item of vendorsList" [value]="item.id">
                  {{ item.vendorName }}
                </ng-option>
              </ng-select>
          </div>
            <!-- Order Number  -->
              <div *ngIf="orderNumber === true" class="dropdownFields">
                <label>Order Number</label>
                <input type="text" class="form-control" formControlName="ORDER_NUMBER_IN">
            </div>
            <!-- INVOICE NO -->
              <!-- <div *ngIf="showInvoiceNo === true" class="dropdownFields">
                <label>Invoice No.</label>
                <input type="text" class="form-control" formControlName="INVOICE_NUMBER">
            </div> -->
            <!-- INVOICE NO -->
            <div *ngIf="showInvoiceNo === true" class="dropdownFields">
              <label>Vendor Invoice No.</label>
              <input type="text" class="form-control" formControlName="VENDOR_INVOICE_IN">
          </div>
           <!-- INVOICE_NUMBER_LIKE NO -->
            <div *ngIf="showInvoiceNo === true" class="dropdownFields">
              <label>Invoice No.</label>
              <input type="text" class="form-control" formControlName="INVOICE_NUMBER_LIKE">
          </div>
            
            <!-- QUICKCODE NAME -->
              <div *ngIf="showQuickCodeName === true" class="dropdownFields">
                <label>Name</label>
                <input type="text" class="form-control" formControlName="NAME_IN">
            </div>

            <div *ngIf="showDateFilter" class="dropdownFields" [ngClass]="{disabled: searchForm.controls['DUMMY_FILTER_TWO'].value}">
              <label>Created At</label>
              <select class="form-control" name="createdAt" formControlName="DUMMY_FILTER_THREE" [(ngModel)]="selectedOption" (change)="onOptionChange($event)">
                <option value="">All</option>
                <option value="today">Today</option>
                <option value="yesterday">Yesterday</option>
                <option value="last-week">Last Week</option>
                <option value="last-month">Last Month</option>
                <option value="current-month">Current Month</option>
                <option value="custom">Custom Date Range</option>
              </select>
              <div class="custom-wrapper" *ngIf="showCustomDateRange">
                <div>
                  <label for="fromDate">From Date:</label>
                  <input class="form-control" name="fromDate" formControlName="CREATED_FROM_DATE" type="datetime-local"/>
                </div>
                <div>
                  <label for="toDate">To Date:</label>
                  <input class="form-control"  name="toDate" formControlName="CREATED_TO_DATE" type="datetime-local" />
                </div>
              </div>
            </div>
          
            <!-- DATE-RANGE -->
            <!-- <div *ngIf="showDateRange"  class="dropdownFields date">
                  <label>Date Range</label>
                  <p-calendar formControlName="DATE_RANGE"
                      selectionMode="range" appendTo="body"
                      placeholder="Start Date - End Date"  (onSelect)="selectRange($event)"></p-calendar>
          </div> -->
          <div *ngIf="showInvoiceId === true" class="dropdownFields" style="visibility: hidden;">
            <label>Vendor Invoice Id</label>
            <input type="text" class="form-control" formControlName="INVOICE_IN">
        </div>

         <!-- Status Dropdown (Visible based on Input) -->
            <div *ngIf="orderStatus === true" class="dropdownFields">
                <label>Status</label>
                <ng-select formControlName="STATUS_IN" placeholder="Select status" appendTo="body">
                    <ng-option *ngFor="let item of statusList" [value]="item.name">
                    {{ item.name }}
                  </ng-option>
                </ng-select>
            </div>

            <div class="dropdownFields" *ngIf="DateofPlacement == true">
              <label>Select Date Range</label>
              <p-calendar formControlName="DATE_RANGE" selectionMode="range" appendTo="body" [readonlyInput]="true"  [maxDate]="today" (onSelect)="selectRange($event)"></p-calendar>
          </div> 

           <!-- QUICKCODE NAME -->
              <div *ngIf="showStateName === true" class="dropdownFields">
                <label>State Name</label>
                <input type="text" class="form-control" formControlName="STATE_IN">
            </div>

             <!-- QUICKCODE NAME -->
              <div *ngIf="showCityName === true" class="dropdownFields">
                <label>City Name</label>
                <input type="text" class="form-control" formControlName="CITY_NAME">
            </div>

             <!-- QUICKCODE NAME -->
              <div *ngIf="showCityCode === true" class="dropdownFields">
                <label>City Code</label>
                <input type="text" class="form-control" formControlName="CITY_CODE">
            </div>

             <!-- routeCode NAME -->
              <div *ngIf="routeCode === true" class="dropdownFields">
                <label>Route Code</label>
                <input type="text" class="form-control" formControlName="ROUTE_CODE_IN">
            </div>

            <div *ngIf="sourceCity === true" class="dropdownFields">
                <label>Source City</label>
                <ng-select formControlName="SOURCE_CITY_IN" placeholder="" appendTo="body">
                 <ng-option *ngFor="let item of locationLists" [value]="item.id">{{item.cityName}}</ng-option>
                </ng-select>
            </div>
            
            <div *ngIf="destinationCity === true" class="dropdownFields">
                <label>Destination City</label>
                <ng-select formControlName="DESTINATION_CITY_IN" placeholder="" appendTo="body">
                   <ng-option *ngFor="let item of locationLists" [value]="item.id">{{item.cityName}}</ng-option>
                </ng-select>
            </div>


            
             <!-- ShowVehicleType NAME -->
              <div *ngIf="ShowVehicleType === true" class="dropdownFields">
                <label>Vehicle Type</label>
                <input type="text" class="form-control" formControlName="VEHICLE_TYPE_IN">
            </div>
            <div *ngIf="ShowVehicleType === true" class="dropdownFields">
                <label>Vehicle Tonnage</label>
                <input type="text" class="form-control" formControlName="VEHICLE_TONNAGE_IN">
            </div>
            <div *ngIf="ShowVehicleType === true" class="dropdownFields">
                <label>Vehicle Capacity </label>
                <input type="text" class="form-control" formControlName="CAPACITY_IN">
            </div>

          
            <!-- Action Buttons -->
            <div class="advance-icon flex-row-reverse flex-end justify-content-start">
                <button class="btn btn-primary ms-1" type="submit">Search</button>
                <button class="btn reset-btn btn-cancel" type="button" (click)="onReset()">Reset</button>
            </div>


           
        </form>
    </div>
</div>